import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function LandingNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", handler);
    return () => window.removeEventListener("scroll", handler);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0A0B0F]/95 backdrop-blur-md border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center">
          <img
            src="https://static.readdy.ai/image/e50d925263add9c47b947a5709171c8c/e78e12178b276a3dafefa66de22e9d3a.png"
            alt="Pixory AI"
            className="h-11 w-auto object-contain"
          />
        </div>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          <a href="#features" className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap">Features</a>
          <a href="#modules" className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap">Modules</a>
          <a href="#testimonials" className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap">Reviews</a>
          <a href="#pricing" className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap">Pricing</a>
        </div>

        {/* Actions */}
        <div className="hidden md:flex items-center gap-4">
          <Link to="/admin" className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap">
            Admin Demo
          </Link>
          <a
            href="#early-access"
            className="bg-[#C8A96E] hover:bg-[#b8965a] text-black text-sm font-semibold px-4 py-2 rounded-full transition-colors cursor-pointer whitespace-nowrap"
          >
            Get Early Access
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-white/60 cursor-pointer"
        >
          <i className={mobileOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-[#0A0B0F]/98 border-t border-white/5 px-6 py-4 space-y-3">
          <a href="#features" onClick={() => setMobileOpen(false)} className="block text-white/60 hover:text-white text-sm py-2 cursor-pointer">Features</a>
          <a href="#modules" onClick={() => setMobileOpen(false)} className="block text-white/60 hover:text-white text-sm py-2 cursor-pointer">Modules</a>
          <a href="#pricing" onClick={() => setMobileOpen(false)} className="block text-white/60 hover:text-white text-sm py-2 cursor-pointer">Pricing</a>
          <Link to="/admin" className="block text-[#C8A96E] text-sm py-2 font-semibold">Admin Demo →</Link>
        </div>
      )}
    </nav>
  );
}
